const systemSettings = [
  {
    path: '/system-settings',
    name: 'system-settings.list',
    component: () => import('@/views/system-settings/SystemSettingsList.vue'),
  },
]

export default systemSettings
